import React, { useState } from 'react';
import MSAHeader from './components/MSAHeader';
import MSATabNavigation from './components/MSATabNavigation';
import ContractOverview from './components/ContractOverview';
import DocumentsSection from './components/DocumentsSection';
import KeyDatesSection from './components/KeyDatesSection';
import SignaturesSection from './components/SignaturesSection';

const MasterServiceAgreementViewer = () => {
  const [activeTab, setActiveTab] = useState('contract');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'contract':
        return <ContractOverview />;
      case 'Parts':
        return <DocumentsSection />;
      case 'documents':
        return <DocumentsSection />;
      case 'dates':
        return <KeyDatesSection />;
      case 'signatures':
        return <SignaturesSection />;
      default:
        return <ContractOverview />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <MSAHeader 
        title="Master Service Agreement"
        documentId="MSA-2025-001"
        lastUpdated="Jan 11, 2025"
        status="Active"
      />
      
      <MSATabNavigation 
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      
      <main className="flex-1 p-6 bg-background">
        <div 
          role="tabpanel" 
          id={`${activeTab}-panel`}
          aria-labelledby={`${activeTab}-tab`}
          className="max-w-7xl mx-auto"
        >
          {renderTabContent()}
        </div>
      </main>
    </div>
  );
};

export default MasterServiceAgreementViewer;